import { Link } from 'react-router-dom'
import { Button, Typography } from '@mui/material'

interface Props {
  text: JSX.Element | string
  to: string
  fullWidth?: boolean
  className?: string
}

export default function LinkButton({ text, to, fullWidth = false, className }: Props): JSX.Element {
  return (
    <Button
      component={Link}
      to={to}
      color="primary"
      variant="contained"
      fullWidth={fullWidth}
      className={className}
      sx={{
        display: 'flex',
        padding: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '12px',
        border: '1px solid #0BB163',
      }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '20px', textTransform: 'none' }}>
        {text}
      </Typography>
    </Button>
  )
}
